module.exports = __webpack_public_path__ + "media/images/lb/973-6c75d7bf465d5a354ebb431e8f055c4d.svg";